module.exports = "textarea{\r\n    height:80px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #f3f3f3;\r\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/sainik-registration/battlecasualty/battlecasualty.component.css
// module id = ./src/app/sainik-registration/battlecasualty/battlecasualty.component.css
// module chunks = main